import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, LoadingSpinner } from "@/components";
import { useUserStore } from "@/store/userStore";
import { UpdateAvatar, UpdateInforForm } from "./components";
import { RoleEnum } from "@/types";
import { useAuth } from "@/contexts/AuthContext";
import { isNaN } from "lodash";
import { ROUTES } from "@/constants/routes";

const UpdateUserInformation = () => {
  const { id } = useParams();
  const { fetchUserById, fetchMyProfile, loading } = useUserStore();
  const { role, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      fetchMyProfile();
      return;
    } else if (isNaN(Number(id))) {
      navigate(ROUTES.ERROR_404);
      return;
    }
    fetchUserById(Number(id));
  }, [id]);

  const getBreadcrumbPath = () => {
    if (
      [RoleEnum.COMPANY_ADMIN, RoleEnum.HEAD_OFFICE_USER].includes(role || RoleEnum.OTHER)
    ) {
      return [
        { label: "事業所管理", path: `/company` },
        { label: "ユーザー詳細", path: "" },
      ];
    }
    if (role === RoleEnum.STORE_MANAGER) {
      return [
        { label: "事業所管理", path: `/store/${user?.store?.id}` },
        { label: "ユーザー詳細", path: "" },
      ];
    }
    return [] as any;
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-full w-full">
        <LoadingSpinner />
      </div>
    );

  return (
    <div className="h-full flex flex-col pb-4">
      {/* Header */}
      <section className="space-y-2 py-4">
        {getBreadcrumbPath().length > 0 && !!id && (
          <Breadcrumb breadcrumbs={getBreadcrumbPath()} />
        )}

        <p className="flex items-center text-lg font-bold leading-7">ユーザー情報</p>
      </section>

      {/* Main */}
      <section className="grid grid-cols-3 gap-4">
        <div>
          <UpdateAvatar />
        </div>
        <div className="col-span-2">
          <UpdateInforForm />
        </div>
      </section>
    </div>
  );
};

export default UpdateUserInformation;
